import TitleToolTip from "./TitleToolTip";
import { MoreInfoIcon } from "../../../assets/icons/iconsProvider";

const MoreInfoIconToolTip = (props) => {
  const { title = "Message" } = props;

  return (
    <TitleToolTip title={title}>
      <MoreInfoIcon className={"more-info-icon"} />
    </TitleToolTip>
  );
};

export default MoreInfoIconToolTip;
